import React, { useEffect } from "react";
import "./Design.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { assets } from "../../Assets/Assets";

function Design() {
  useEffect(() => {
    AOS.init({
      duration: 800,
    });
  }, []);

  return (
    <div className="design">
      <div className="overlay"></div>
      <div className="content-box">
        <h2>It's Our Confidence</h2>
        <h4>Elevating Your Vision with Advanced Technologies</h4>
        <p>
          At Spine Codes, we pride ourselves on our deep expertise in advanced
          technologies. We are dedicated to delivering successful projects
          through innovation and excellence. We specialize in web and mobile app
          development, helping to bring your vision to life with the
          latest advancements.
        </p>
      </div>
      <ul>
        <li className="react">
          <img src={assets.reactimg} alt="react" loading="lazy" />
        </li>
        <li className="bootstrap">
          <img src={assets.boostra} alt="bootstrap" loading="lazy" />
        </li>
        <li className="figma">
          <img src={assets.figma} alt="figma" loading="lazy" />
        </li>
        <li className="css">
          <img src={assets.css1} alt="css" loading="lazy" />
        </li>
        <li className="python">
          <img src={assets.python1} alt="python" loading="lazy" />
        </li>
        <li className="ai">
          <img src={assets.ai} alt="ai" loading="lazy" />
        </li>
        <li className="flutter">
          <img src={assets.Flutter} alt="flutter" loading="lazy" />
        </li>
        <li className="js">
          <img src={assets.js} alt="js" loading="lazy" />
        </li>
        <li className="html">
          <img src={assets.html1} alt="html" loading="lazy" />
        </li>
        <li className="dart">
          <img src={assets.dart} alt="dart" loading="lazy" />
        </li>
        <li className="Mongo">
          <img src={assets.mongo} alt="mongodb" loading="lazy" />
        </li>
        <li className="firebase">
          <img src={assets.firebase} alt="firebase" loading="lazy" />
        </li>
      </ul>
    </div>
  );
}

export default Design;
